<template>
  <v-flex class="profiles">
    <v-layout align-center>
      <h1>Profiles</h1>
      <v-spacer />
      <v-select
        v-model="disabledSort"
        class="mt-0"
        style="margin-bottom: -15px; width: 230px; flex-grow: 0;"
        :items="sortOptions"
        label="User Types"
        dense
        @input="getUsers"
      ></v-select>
    </v-layout>
    <v-card>
      <v-list v-if="loaded" two-line class="mt-3 pt-0 pb-0">
        <template v-for="(profile, index) in users">
          <v-list-item
            :key="profile.id"
            :class="{ 'disabled-profile': profile.disabled }"
            @click="viewProfile(profile)"
          >
            <v-layout align-center>
              <div v-if="getNameFromUser(profile)" class="mr-7">
                <v-icon color="primary" class="mr-2">person</v-icon>
                {{ getNameFromUser(profile) }}
              </div>
              <v-icon color="primary" class="mr-2">email</v-icon>
              {{ profile.email }}
              <template v-if="profile.disabled">
                <v-spacer />
                <b style="color: #fb376c;font-size: .8rem">DISABLED</b>
              </template>
            </v-layout>
          </v-list-item>
          <v-divider v-if="index + 1 < users.length" :key="index" />
        </template>
      </v-list>
      <v-alert
        v-if="users.length === 0 && loaded"
        :value="true"
        type="info"
        color="primary"
        outlined
      >
        There are no profiles to display
      </v-alert>
    </v-card>

    <v-dialog v-model="viewProfileModal" persistent max-width="600" scrollable>
      <view-profile
        v-if="viewProfileModal"
        :key="currentUser.id"
        :user="currentUser"
        @close="viewProfileModal = false"
      />
    </v-dialog>
    <v-progress-linear
      v-if="!loaded"
      color="info"
      :indeterminate="true"
      class="mt-3"
    />
  </v-flex>
</template>

<script>
import { usersCollection } from '../firebaseConfig.js';
import ViewProfile from '@/components/ViewProfile';
import getNameFromUser from '@/helpers/getNameFromUser.js';

export default {
  name: 'Profiles',
  components: {
    ViewProfile
  },
  data() {
    return {
      loaded: false,
      users: [],
      currentUser: null,
      viewProfileModal: false,
      disabledSort: null,
      sortOptions: [
        {
          text: 'All',
          value: null
        },
        {
          text: 'Active',
          value: false
        },
        {
          text: 'Disabled',
          value: true
        }
      ]
    };
  },
  computed: {
    currentLocationId() {
      return this.$store.state.currentLocation.id;
    }
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    getNameFromUser,
    viewProfile(user) {
      this.currentUser = user;
      this.viewProfileModal = true;
    },
    getUsers() {
      let request;
      let disabledSort = this.disabledSort;
      if (disabledSort == null) {
        request = usersCollection.where(
          'location_id',
          '==',
          this.currentLocationId
        );
      } else if (!disabledSort) {
        request = usersCollection
          .where('location_id', '==', this.currentLocationId)
          .where('disabled', '==', false);
      } else {
        request = usersCollection
          .where('location_id', '==', this.currentLocationId)
          .where('disabled', '==', true);
      }
      this.$bind('users', request)
        .then(() => {
          this.loaded = true;
        })
        .catch(error => {
          this.$store.dispatch('createSnackbar', {
            color: 'error',
            text: `Error loading profiles: ${error}`
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.disabled-profile {
  background-color: rgba(#fb376c, 0.1);
}
</style>
